/*
* Quantity change
*/
jQuery(document).on('click', '.qty-wrapper .qty-change', function(){
  var $qtyField = $(this).parent().find('.qty-input');
  var soq = parseInt($qtyField.attr('step')) || 1;
  var qty = parseInt($qtyField.val());
  if(qty % soq !== 0){
    var rem = qty % soq;
    qty -= rem;
  }
  if($(this).hasClass('qty-plus')){
    qty += soq;
  } else if($(this).hasClass('qty-minus')){
    qty -= soq;
    if(qty <= 0){
      if($qtyField[0].hasAttribute('data-cartitem-quantity')){
        qty = 0;
      } else {
        qty = soq;
      }
    }
  }
  if($qtyField[0].hasAttribute('data-cartitem-quantity')){ 
    $qtyField.val(qty).trigger('change');
  } else {
    $qtyField.val(qty);
  }
});
jQuery(document).on('change', '.qty-wrapper .qty-input', function(){
  var $qtyField = $(this);
  if($qtyField[0].hasAttribute('data-cartitem-quantity')) return;
  var soq = parseInt($qtyField.attr('step')) || 1;
  var qty = parseInt($qtyField.val());
  if(qty % soq !== 0){
    var rem = qty % soq;
    qty -= rem;
  }
  if(qty <= 0) qty = soq;
  $qtyField.val(qty);
});